import { render } from "./filePreviewer.vue?vue&type=template&id=b39b6f96&scoped=true&ts=true"
import script from "./filePreviewer.vue?vue&type=script&lang=ts"
export * from "./filePreviewer.vue?vue&type=script&lang=ts"

import "./filePreviewer.vue?vue&type=style&index=0&id=b39b6f96&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39b6f96"]])

export default __exports__